import { API_PREFIX } from '../../../shared/constants';
import { createRestClient, assertStatusCode } from '../rest';
import { Cart } from '@pegasus/cart/types/cart';

export const fetchCart = (): Promise<Cart> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .get(`/cart`)
        .then(assertStatusCode([200]))
        .then(response => response.json());
};

export const removeItem = ({ simpleSku }: { simpleSku: string }): Promise<void> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .delete(`/cart/items/${simpleSku}`)
        .then(assertStatusCode([204]))
        .then(_ => undefined);
};

export const extendCart = (): Promise<void> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .put(`/cart`)
        .then(assertStatusCode([204]))
        .then(_ => undefined);
};
